import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {Extracurricular} from "../../models/extracurricular.model";
import {ExtracurricularService} from "../../services/extracurricular.service";
import {SettingService} from "../../services/setting.service";
import {ExtracurricularCategory} from "../../models/extracurricular-category.model";
import {ExtracurricularCategoryService} from "../../services/extracurricular-category.service";
import {TranslateService} from "../../services/translate.service";
import {SchoolActivityModel} from "../../models/school-activity-model";
import {SchoolProgramService} from "../../services/school-program.service";

@Component({
  selector: 'app-select-school-activity',
  templateUrl: './select-school-activity.component.html',
  styleUrls: ['./select-school-activity.component.css']
})
export class SelectSchoolActivityComponent implements OnInit, OnChanges {

  heading = 'School Activity Select';
  loading: boolean;
  schoolActivityValue: SchoolActivityModel;
  schoolActivityList: SchoolActivityModel[] = [];
  localStorageName = 'client.spadata';

  @Output()
  schoolActivityChanged = new EventEmitter<SchoolActivityModel>();

  @Output()
  eventData = new EventEmitter<any>();

  @Input()
  isDisabled = false;

  @Input()
  school_program_id = null;

  @Input()
  academic_year: any = null;

  schoolActivityData :any = [];

  @Input()
  search = null;

  @Input()
  school_program_category_id: any = null;

  @Input()
  has_payment = false;

  @Input()
  student_id = null;

  @Input()
  usingLocalStorage = true;

  constructor(
    private translate: TranslateService,
    private schoolProgramService: SchoolProgramService,
    private setting: SettingService
  ) {
  }

  ngOnInit() {
    this.translate.load('extracurricular');
    this.getSchoolActivities();
  }

  ngOnChanges(changes: any): void {
      // @ts-ignore
      this.schoolActivityValue = null;
      if (this.school_program_category_id) {
        this.getSchoolActivities();
      } else {
        this.schoolActivityData = [];
      }
  }

  onChange(item: any) {
    if (!item) {
      // @ts-ignore
      this.schoolActivityChanged.emit(null);
      return;
    }
    this.schoolActivityChanged.emit(item);
    this.onSaveLocalStorage();
  }

  getSchoolActivities() {
    const data = {
      school_program_id: this.school_program_id,
      academic_year: this.academic_year,
      pagination: false,
      orderBy: 'activity_name',
      sort: 'asc',
      search: this.search,
      school_program_category_id: this.school_program_category_id,
      approved: true,
      has_payment: this.has_payment,
      student_id: this.student_id
    }
    if (this.student_id) {
      this.schoolProgramService.getSchoolProgramActivityStudent({ academic_year: this.academic_year, student_id: this.student_id }).subscribe(
        (response: any) => {
        if(response['status']) {
          this.schoolActivityData = response['data'];
          this.onCheckLocalStorage();
          const nameOnly = this.schoolActivityData.map((item: any) => {
            return {name: item.activity_name}
          })
          this.eventData.emit(response['data']);
        } else {
        }
      });
    } else {
      this.schoolProgramService.getSchoolProgramActivity(data).subscribe((
          response: any) => {
        if(response['status']) {
          this.schoolActivityData = response['data'];
          this.onCheckLocalStorage();
          const nameOnly = this.schoolActivityData.map((item: any) => {
            return {name: item.activity_name}
          })
        } else {
        }
      })
    }
  }

  onCheckLocalStorage() {
    if (!this.localStorageName) {
      return;
    }
    if (!this.usingLocalStorage) {
      return;
    }

    this.loading = false;
    const val = JSON.parse(<string>this.setting.getConfig(this.localStorageName));
    if (val) {
      // @ts-ignore
      this.schoolActivityValue = this.schoolActivityData
        .find((i: any) => +i.school_program_activity_id === +val.school_program_activity_id);
      if (this.schoolActivityValue) {
        this.schoolActivityChanged.emit(this.schoolActivityValue);
      }
    }
  }

  onSaveLocalStorage() {
    if (!this.usingLocalStorage) {
      return;
    }
    this.setting.setConfig(this.localStorageName, JSON.stringify(this.schoolActivityValue));
  }
}
